<template>
  <Tooltip
    v-if="isVisible"
    isMarkdown
    orientation="bottom"
    :text="tooltipMessage"
  >
    <StatusBadge
      :status="type"
      :text="text"
      title=""
    />
  </Tooltip>
</template>

<script>
import {
  StatusBadge,
  Tooltip,
} from '@jumpcloud/ui-components';
import { passwordStrengthStatus } from 'client/PasswordManager/PasswordManagerConstants';
import DateUtil from 'client/util/DateUtil';
import PasswordManagerUtils from 'client/PasswordManager/PasswordManagerUtils';

export default {
  name: 'PasswordManagerPasswordScoreStatus',

  components: {
    StatusBadge,
    Tooltip,
  },

  PasswordManagerUtils,

  props: {
    hasPasswords: {
      type: Boolean,
      required: true,
    },

    passwordScore: {
      type: Number,
      required: false,
      default: 0,
    },

    scoreUpdatedAt: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    currentPasswordsStrength() {
      return this.$options.PasswordManagerUtils.getPasswordStrength(this.passwordScore);
    },

    isVisible() {
      return this.passwordScore !== -1;
    },

    text() {
      return this.hasPasswords ? this.currentPasswordsStrength : 'no passwords';
    },

    tooltipMessage() {
      if (!this.hasPasswords) { return 'No passwords'; }
      if (this.scoreUpdatedAt) {
        return `Last updated
        **${DateUtil.formatDateTime(this.scoreUpdatedAt)}**`;
      }
      return this.text;
    },

    type() {
      return this.hasPasswords ? passwordStrengthStatus[this.currentPasswordsStrength] : 'inactive';
    },
  },
};
</script>
